// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"busySpinner_spinnerContainer__TBE-K","spinnerStyle":"busySpinner_spinnerStyle__b3NvH"};